import React from 'react';
import styles from './Card.module.css';
import Card from './Card';
import CardComing from "./CardComing";
import CardRating from "./CardRating";

const CardGrid = ({ cards, CardComponent }) => {
    return (
        <div className={styles.cardGrid}>
            {cards.map((card) => (
                <CardComponent
                    key={card.id}
                    {...card}
                />
            ))}
        </div>
    );
};

export default CardGrid;
